export default __webpack_public_path__ + "static/media/artNude-2.6ba48658.jpg";